import { IMulticonsultProject } from "@mctypes/global.types";
import { AppThunk } from "../../../../store";
import { makeTypedSetter } from "../makeTypedSetter";
import { setEditedDataInRedux } from "../reportSlice";

export const setEksempelValue = makeTypedSetter<IEksempelrapport, 101>(101);

import { doGetSingleMaconomyProject } from "../reportBoardAPI"; // justera import
import { setEditedValueInRedux } from "../reportSlice"; // där du har setEditedValueInRedux
import { setShowFailedMessageThunk, setShowSuccessMessageThunk } from "../../../../global/globalSlice";
import { ToastMessagesEnums } from "../../../../mc-shared/sharedConstants";
import { IEksempelrapport } from "../../../../mc-shared/reportSchemas/eksempelRapportSchema";
import { toggleChapterInTree } from "../../../../components/ReportChapterTree/reportChaptersTreeUtils";
import { applyAllRules } from "./eksempelRapportUtils";

export const EKSEMPEL_RAPPORT_ID = 101;

export const fetchMaconomyAndHydrateEksempelGenerellInfoThunk = (): AppThunk => async (dispatch, getState) => {
  const project = getState().adminReducer.project;

  try {
    const multiconsultProject: IMulticonsultProject = await doGetSingleMaconomyProject(project._id);
    if (!multiconsultProject) {
      dispatch(setShowFailedMessageThunk("Ingen prosjektdata funnet i Maconomy"));
      return;
    }

    dispatch(setShowSuccessMessageThunk("Hentet data fra maconomy"));

    dispatch(
      setEditedValueInRedux({
        code: EKSEMPEL_RAPPORT_ID,
        path: "generellInfo.utarbeidetAv",
        value: multiconsultProject.ProjectManager ?? "",
      }),
    );

    // Om ni har något fält i maconomy som matchar bättre för dessa tre,
    // byt mapping här. Annars lämnar vi dem orörda (för att inte skriva över användarinput).
    dispatch(
      setEditedValueInRedux({
        code: EKSEMPEL_RAPPORT_ID,
        path: "generellInfo.oppdragsnavn",
        value: multiconsultProject.DisplayName ?? "",
      }),
    );
    dispatch(
      setEditedValueInRedux({
        code: EKSEMPEL_RAPPORT_ID,
        path: "generellInfo.oppdragsgiver",
        value: multiconsultProject.CustomerName ?? "",
      }),
    );
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.SETTINGS_UPDATED));
  } catch (error) {
    dispatch(setShowFailedMessageThunk("Kunne ikke hente data fra maconomy"));
    throw error;
  }
};

export const thunkEksempelKapittelToggled =
  (chapterId: string, next: boolean): AppThunk =>
  (dispatch, getState) => {
    const edited = getState().reportReducer.editedData[101] as IEksempelrapport | null;
    if (!edited) return;

    // 1) user toggle
    const toggled = toggleChapterInTree(edited.kapitler, chapterId, next);

    // 2) rules (sticky) => returnerar både kapitler + toast-messages
    const ruleRes = applyAllRules(toggled);

    // Ingen ändring => gör inget
    if (ruleRes.kapitler === edited.kapitler) return;

    // 3) skriv tillbaka uppdaterad data
    dispatch(
      setEditedDataInRedux({
        code: 101,
        data: {
          ...edited,
          kapitler: ruleRes.kapitler,
        },
      }),
    );

    // 4) unika meddelanden per regel
    for (const msg of ruleRes.messages) {
      dispatch(setShowSuccessMessageThunk(msg));
    }
  };
